import { render, staticRenderFns } from "./FabuTuiguang.vue?vue&type=template&id=2f5e590b&scoped=true"
import script from "./FabuTuiguang.vue?vue&type=script&lang=js"
export * from "./FabuTuiguang.vue?vue&type=script&lang=js"
import style0 from "./FabuTuiguang.vue?vue&type=style&index=0&id=2f5e590b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5e590b",
  null
  
)

export default component.exports